// <film-modal> — click any [data-film] button: a hairline draws, opens to a 16:9 frame; Esc / backdrop / Close.
class FilmModal extends HTMLElement {
  connectedCallback() {
    this.box = this.querySelector('.film');
    document.addEventListener('click', (e) => {
      const t = e.target.closest('[data-film]');
      if (t) { e.preventDefault(); this.open(t); }
    });
    // programmatic: document.dispatchEvent(new CustomEvent('film:open', { detail: { src, title, meta, poster, trigger } }))
    document.addEventListener('film:open', (e) => {
      const d = e.detail || {}; const t = document.createElement('button');
      Object.assign(t.dataset, { filmSrc: d.src || '', filmTitle: d.title || '', filmMeta: d.meta || '', filmPoster: d.poster || '' });
      this.open(t, d.trigger);
    });
    this.box.addEventListener('click', (e) => {
      if (e.target === this.box || e.target.closest('[data-film-close]')) this.close();
    });
    document.addEventListener('keydown', (e) => {
      if (this.box.hidden) return;
      if (e.key === 'Escape') this.close();
      if (e.key === 'Tab') { e.preventDefault(); (document.activeElement === this.video ? this.querySelector('.film-x') : this.video)?.focus(); }
    });
  }
  open(t, trigger) {
    this.prev = trigger || (t.isConnected ? t : document.activeElement);
    this.querySelector('.film-t').textContent = t.dataset.filmTitle || '';
    this.querySelector('.film-m').textContent = t.dataset.filmMeta || '';
    const v = document.createElement('video');
    v.src = t.dataset.filmSrc; v.controls = true; v.playsInline = true; v.autoplay = true;
    if (t.dataset.filmPoster) v.poster = t.dataset.filmPoster;
    v.setAttribute('aria-label', t.dataset.filmTitle || '');
    this.querySelector('.film-v').replaceChildren(v);
    this.video = v;
    this.box.hidden = false;
    document.documentElement.classList.add('lock');
    document.querySelectorAll('video[data-autoplay]').forEach((a) => { a.setAttribute('data-paused', ''); a.pause(); });
    setTimeout(() => this.querySelector('.film-x').focus({ preventScroll: true }), 50);
  }
  close() {
    this.video?.pause();
    this.querySelector('.film-v').replaceChildren();
    this.box.hidden = true;
    document.documentElement.classList.remove('lock');
    document.querySelectorAll('video[data-paused]').forEach((a) => a.removeAttribute('data-paused'));
    this.prev?.focus?.({ preventScroll: true });
    document.dispatchEvent(new CustomEvent('film:closed'));
  }
}
if (!customElements.get('film-modal')) customElements.define('film-modal', FilmModal);
